
const POLKADOT = 'polkadot';
const KUSAMA = 'kusama';

export {
  POLKADOT,
  KUSAMA
};
